import { useApiQuery } from '../query';

export function useResellerProfile(enabled = false) {
  return useApiQuery(
    '/account-management/v1/resellers/reseller-profile',
    undefined,
    { enabled, refetchOnWindowFocus: false }
  );
}
